import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslate } from 'hooks/useTranslate';

import { useAcceptIncentiveOfferModal } from '../context/AcceptIncentiveOfferModalContext';

const AcceptIncentiveOfferModalHeader: FC = () => {
  const { t } = useTranslate();
  const { actions } = useAcceptIncentiveOfferModal();

  return (
    <Modal.Header>
      <h5 className="modal-title">{t('AcceptBuyOffer')}</h5>
      <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default AcceptIncentiveOfferModalHeader;
